import * as Sentry from "@sentry/nextjs";
import { APIS_MAP } from "@/setting/setting";

declare const window: any;
declare const fetch:any;

const call = async (url: string, body?: any) =>
{
    if (body?.disabled) 
    {
        return { status : false };
    }

    let result;

    // Substitui a origem da API no client
    if (typeof window !== "undefined" && APIS_MAP) 
    {
        const currentHostname = window.location.hostname;
        const apiUrl = APIS_MAP[currentHostname];

        if (apiUrl) 
        {
            url = url.replace(process.env.NEXT_PUBLIC_API_SOURCE_URL || "", apiUrl);
        }
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try 
    {
        const headers: Record<string, string> = {
            "Accept"       : "application/json",
            "Content-Type" : "application/json",
        };

        const response = await fetch(url, {
            method      : "POST",
            body        : body ? JSON.stringify(body) : "{}",
            headers     : headers,
            keepalive   : true,
            credentials : "include",
            //cache       : "force-cache",
            signal      : controller.signal,
            next        : { cache : "no-cache" },
        });

        clearTimeout(timeoutId);

        const contentType = response.headers.get("content-type");

        if (!response.ok || !contentType?.includes("application/json")) 
        {
            const text = await response.text();
            
            console.warn("❌ Resposta inválida da API:", response.status, text);

            return {
                status      : false,
                serverError : true,
            };
        }

        result = await response.json();
    } 
    catch (e: any) 
    {
        clearTimeout(timeoutId);

        // AbortError = usuário trocou de página ou timeout
        if (e.name === "AbortError") 
        {
            console.warn("⚠️ Requisição cancelada (AbortError)", url);
            return { status : false, cancelled : true };
        }
    
        // Envia para o Sentry
        Sentry.captureException(e, {
            tags : {
                from      : "call()",
                requestId : undefined,
                url,
            },
            extra : {
                body,
                hint : "Verifique se o servidor está online ou se houve erro de CORS.",
            },
        });
    
        console.error("❌ Erro durante chamada:", e);
    
        result = {
            status      : false,
            serverError : true,
        };
    }

    return result;
};

const callFormData = async (url: string, body?: any) => 
{
    const headers: any = {
        //"Accept" : "application/json",
        //"Content-Type": "multipart/form-data",
        "Access-Control-Allow-Credentials" : "true",
    };

    // const form = new FormData()
    // const keys = Object.keys(body)
    // for(let i =0; i<keys.length; i++){
    //   console.log(keys[i])
    //     console.log(body[keys[i]])
    //   form.append(keys[i], body[keys[i]])
    // }
    // console.log(form)
    // console.log(body)

    const response = await fetch(url, {
        method      : "POST",
        body        : body,
        headers     : headers,
        credentials : "include"
    });          

    const data = await response.json();      

    return data;
};

const calls = async (...calls: any) => 
{
    const promises = [];

    for (const call of calls) 
    {
        promises.push(call);
    }

    return await Promise.all(promises);
};

const revalidateResults = (results: any) => 
{
    let error       = false;
    let serverError = false;

    for (const result of results) 
    {
        if (!result.status)
        {
            error = true;
        }

        if (result.serverError)
        {
            serverError = true;
        }
    }

    if (error) 
    {
        return {
            notFound   : !serverError,
            revalidate : true,
        };
    }

    return {
        revalidate : false,
    };
};

const parseResponse = async (maps: any, result: any) => 
{
    if (result.data && maps.model) 
    {
        result.data = new maps.model(result.data);
    } 
    else if (result.collection && maps.collection) 
    {
        result.collection = new maps.collection(result.collection);
    }

    return result;
};

export { 
    call, 
    callFormData, 
    calls, 
    parseResponse, 
    revalidateResults,
};
